/**
 * @file 项目List stroe
 * @author sunyingying01
 */

import {flow, makeObservable, observable, action} from 'mobx';
import {JobsListStore} from '../jobs/JobsListStore';
import {ProjectsStore} from './ProjectsStore';

export class ProjectsListStore {
    // 用户ID
    user_id: string = '';
    // 项目列表
    projectList: ProjectsStore[] = [new ProjectsStore()];
    // 选中的项目id
    selectedProjectId: string = '';
    // 选中的项目详情
    selectedProject: ProjectsStore | undefined = new ProjectsStore();

    loading: boolean = false;

    /** 该项目下的任务列表 */
    jobsListStore: JobsListStore;

    constructor(user_id: string) {
        this.user_id = user_id;
        this.jobsListStore = new JobsListStore();
        makeObservable(this, {
            user_id: observable,
            projectList: observable,
            loading: observable,
            selectedProjectId: observable,
            selectedProject: observable,
            fetchList: flow.bound,
            setSelectedProjectId: action,
            jobsListStore: observable
        });
    }

    /**
     * 设置选中的项目ID
     * @param id 项目ID
     */
    setSelectedProjectId(id: string) {
        this.selectedProjectId = id;
        this.jobsListStore.projectId = id;
        this.jobsListStore.fetchList();
    }

    /**
     * 获取项目列表
     * @function fetchList
     * @memberof ProjectsListStore
     * @description 从服务器获取项目列表数据并更新store状态
     * @returns {Promise<void>} 异步操作结果
     */
    * fetchList(this: ProjectsListStore) {}
}


